import { render, staticRenderFns } from "./RegisterEmailCard.vue?vue&type=template&id=13b7a125&"
import script from "./RegisterEmailCard.vue?vue&type=script&lang=js&"
export * from "./RegisterEmailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports